import React, { SVGProps } from 'react'

const SvgCheck = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'var(--color-highlight)'}
      d="M8.545 11.97a.75.75 0 0 0-1.06 1.06l2.828 2.83a.75.75 0 0 0 1.06 0l5.657-5.658a.75.75 0 1 0-1.06-1.06l-5.127 5.126-2.298-2.298Z"
    />
  </svg>
)
export default SvgCheck
